import React, { useContext } from 'react'
import { Context } from '../Context/Context'

export default function WithdrawDetailModal() {

    const { withdrawDetailModalStatus, withdrawDetailModal, setWithdrawDetailModalStatus } = useContext(Context)

    return (
        <>
            {withdrawDetailModalStatus && <div className="modal-overlay">
                <div className="modal-container">
                    <h2 className="modal-heading">Method - {withdrawDetailModal?.withdraw_details?.method}</h2>
                    {withdrawDetailModal?.withdraw_details?.method === "bank" &&
                        < ul className="point-list">
                            <li className="point-item">Holder Name: {withdrawDetailModal?.withdraw_details?.account_holder_name}</li>
                            <li className="point-item">Account Number :{withdrawDetailModal?.withdraw_details?.account_number}</li>
                            <li className="point-item">IFSC: {withdrawDetailModal?.withdraw_details?.ifsc_code}</li>
                        </ul>
                    }
                    {withdrawDetailModal?.withdraw_details?.method === "upi" &&
                        < ul className="point-list">
                            <li className="point-item">UPI ID: {withdrawDetailModal?.withdraw_details?.upi}</li>
                        </ul>
                    }
                    {withdrawDetailModal?.withdraw_details?.method === "phonepe" &&
                        < ul className="point-list">
                            <li className="point-item">Phonepe Number: {withdrawDetailModal?.withdraw_details?.phonepe}</li>
                        </ul>
                    }
                    <button className="close-button" onClick={() => setWithdrawDetailModalStatus(false)}>Close</button>
                </div>
            </div >}
        </>
    )
}
